import { gameSignals } from '@/bridge/gameSignals';
import { uiCommandBus } from '@/bridge/uiCommandBus';
import { t } from '@/i18n';

/**
 * Plan #1 §4.3 — assist affordance.
 * - When assistAvailable: a tappable pill that emits the assist:reveal command.
 * - When assistHint is a zone: a STATIC foil ring (no animation → reduced-motion
 *   safe) + an aria-live caption. The node UNMOUNTS when hint clears (not blanked).
 * Mounted by App only when scene==='PLAY' && gameMode!=='practice'.
 */
export function HintAffordance() {
  const available = gameSignals.assistAvailable.value;
  const hint = gameSignals.assistHint.value;

  return (
    <>
      {available && (
        <div class="fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom)+12px)] z-30 flex justify-center pointer-events-none">
          <button
            type="button"
            class="pointer-events-auto inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foil text-bg font-mono text-[11px] uppercase tracking-[0.2em] font-bold shadow-lg"
            onClick={() => uiCommandBus.emit({ type: 'assist:reveal' })}
          >
            {t('assist.revealZone')}
          </button>
        </div>
      )}
      {hint && (
        <>
          <div
            data-testid="assist-ring"
            data-zone={hint}
            class="fixed inset-0 z-20 pointer-events-none flex items-center justify-center"
            aria-hidden="true"
          >
            <span class="w-16 h-16 rounded-full border-2 border-foil/80" />
          </div>
          <p class="sr-only" aria-live="polite">
            {t('assist.hintCaption', { position: t(`archetype.position.${hint}` as never) })}
          </p>
        </>
      )}
    </>
  );
}
